import React, { Component } from 'react';
import DistributionComp from './csat-report/distribution.component';
import { CsatTotalComp } from './csat-report/csat-total.component';
import AverageRating from './csat-report/rating.component';
import './report-page.component.css';

class CsatReportPage extends Component {

    render() {
        return (
            <div>
                <div className="container-mt-7 report-main-container">
                    <CsatTotalComp />
                    <DistributionComp />
                    <AverageRating />
                </div>
            </div>
        )
    }

}

export default CsatReportPage;